import React from 'react';
import { GetQuestionsConfiguration } from './Configuration/QuestionConfiguration';
import GetPatientPhotos from './QuestionsTypes/GetPatinentPhotos';
import axios from 'axios';
import Loader from './../../Components/Loader/Loader'
import { Panel, PanelGroup } from 'react-bootstrap';
import PhotosCarousel from './Carousel/PhotosCarousel';
import Card from "components/Card/Card.jsx";
import Parse from 'parse';
import {Admin} from './../../../configurations/Admin';


class PhotosUpload extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      questions: GetQuestionsConfiguration(),
      photos:[],
      loading: false,
      imageCounter: 0,
      imageCounterTotal:0,
      imagesLoaded: []
    }
    this.onSave = this.onSave.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    // You don't have to do this check first, but it can help prevent an unneeded render
    if (nextProps.startTime !== this.state.startTime) {
      const { patient} = nextProps;
      this.setState({
          patient:patient
      });
    }
  }

  onSave = async () => {
    let currentUser = Parse.User.current();
    if(currentUser.get("username") === Admin.user_admin){
      this.setState({isError:true});
      return;
    }



    let phoneDoctor = currentUser.get("phone");
    let phonePatient = this.props.patient.get("phone");  

    const directory = `${phoneDoctor}/${phonePatient}`;
    const imagesLoaded = this.state.photos;
    const baseUrl = "https://drmoons.s3-eu-west-1.amazonaws.com/"
    let imagesUrl= [];

    if(imagesLoaded.length > 0){
      this.setState({
        loading: true,
        imageCounterTotal: imagesLoaded.length
      });
  
      let imageCounter = 0;
      for(let index in imagesLoaded){
        const { name } = imagesLoaded[index];
        try {
          const imageName =  `${phonePatient}-${name}-imagen.jpg`;
          imagesUrl.push({url: this.getImageUrl(baseUrl, directory, imageName), name: name});
          const uploadedImages= await this.uploadFile(imagesLoaded[index].file, directory, imageName, false, "Imagen paciente");
          imageCounter+=1;
          this.setState({
            imageCounter: imageCounter
          });
        } catch (error) {
          console.log("ERROR", error);        
        }
      }
  
    }
    
    const {patient} = this.props;

    let imagesLoadedPreviously= patient.get("imagesLoaded");
    imagesUrl = this.updateImagesLoaded(imagesUrl, imagesLoadedPreviously);
    const Patient = Parse.Object.extend('Patient');
    const query = new Parse.Query(Patient);
    let patientFounded = await query.get(patient.id);
    patientFounded.set("imagesLoaded", imagesUrl);
    await patientFounded.save();
    
    this.setState({
      loading: false,
    });

    // this.setState({loading: false});
  }

  updateImagesLoaded = (newImages, oldImages) => {
    const imagesNames = ["frontSerious","trueSmile","profileLeft", "profileRight","frontOcclusion","rightLateralOcclusion","leftLateralOcclusion","superiorOcclusion","lowerOcclusion","overbite"]
    
    if(newImages === null || newImages.length <= 0){
      if(oldImages){
        if(oldImages === "" || oldImages === null){
          return [];
        }
        else{
          return oldImages
        }
      }else{
        return [];
      }
    }
    let finaleImages = [];
    for(let index in imagesNames){
      let imageFounded = this.getElementByName(newImages, imagesNames[index]);
      if(imageFounded !== null){
        finaleImages.push(imageFounded);
        continue;
      }
      imageFounded = this.getElementByName(oldImages, imagesNames[index]);
      if(imageFounded !== null){
        finaleImages.push(imageFounded);
      }
    }
    return finaleImages;
  }

  getElementByName(items, name){
    if(items === null){
      return null;
    }
    for(let item in items){
      if(items[item].name === name){
        return items[item];
      }
    }
    return null;
  }

  getImageUrl = (baseUrl, directory, name) =>{
    return `${baseUrl}${directory}/${name}`;
  }

  onChangeImageHandler = (file, name) => {
    let imagesLoaded = this.state.photos;
    imagesLoaded.push({file: file, name: name});
  }

  uploadFile = (file, directory, filename, updated, fileDesc)=>{

    let bucket = 'drmoons';
    let ACL = 'public-read';
    let formData = new FormData();
    let uploadUrl = 'https://upload.mymoons.mx/upload';
    formData.set('file', file);
    formData.set('filename', `${filename}`);
    formData.set('bucket', bucket);
    formData.set('ACL', ACL);
    formData.set('directory', directory);

    return axios.post( uploadUrl, formData, null);
  }

  updateQuestionsWithPatientData = (patient) => {
    let preloadedImates = patient.get("imagesLoaded");
    this.setState({imagesLoaded: preloadedImates});
  }

  render() {
    const {patient} = this.props;
    if(patient === null){
      return <p>cargando...</p>
    }

    let preloadedImages=[];
    if(patient.id !== 0){
      preloadedImages = patient.get("imagesLoaded");
    }

    const {loading, isError} = this.state;
    if(loading){
      const {imageCounter, imageCounterTotal} = this.state;
      return (
        <Loader
          loadingText="Estamos cargando tus fotografias, esto puede tardar unos minutos, por favor, no salgas ni recargues esta pantalla."
          subText={`Cargando ${imageCounter}/${imageCounterTotal}`}
        />
      )
    }
    else{
      let errorOnForm = null;
      if(this.state.isError){
        errorOnForm = <p className="error text-center">Existen algunos errores en el formulario</p>
      }
      return(
      
        <div>
          {loading}
  
          <div className="vertical-separator-20px"></div> 

          <div className="row">
            <div className="col-md-12"> 
              <h3>Fotografías</h3>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
            <PanelGroup
              accordion
              id="panels"
              ref="panels"
              onClick={() => this.forceUpdate()}
            >
              <Panel eventKey="1">
                <Panel.Heading>
                  <Panel.Title toggle>Fotografías cargadas anteriormente <i className="fa fa-sort-desc"></i></Panel.Title>
                </Panel.Heading>
                <Panel.Body collapsible>
                  <PhotosCarousel
                    photos={preloadedImages}
                  />
                </Panel.Body>
              </Panel>
            </PanelGroup>

              
            </div>
          </div>
  
          <GetPatientPhotos
            onChangeImageHandler={this.onChangeImageHandler}
          />
  
          <div className="vertical-separator-50px"></div> 
  
  
          <div className="row justify-content-center">
            <div className="col-md-4 col-md-offset-4">
              {errorOnForm}
              <button
                className="button-outlined"
                onClick={this.onSave}
                >
                Guardar
              </button>
            </div>
          </div>
  
          <div className="vertical-separator-30px"></div> 

  
        </div>
      );
    }
    
  }
}

export default PhotosUpload;



// WEBPACK FOOTER //
// ./src/views/Forms/Patient/PhotosUpload.js